module.exports = __webpack_public_path__ + "img/apple.8ea40d41.svg";